// removed by extract-text-webpack-plugin
module.exports = {"cellHeading":"DataTable--cellHeading--JWMUMBvM","sortable":"DataTable--sortable--3J764z8V"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/DataTable/DataTable.css
// module id = 1285
// module chunks = 2